/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

import styled from '@emotion/styled';
import { IDetailsContainerProps } from './types';

export const Container = styled.div({
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  flexBasis: 'content',
  height: '100%',
});

export const SummaryContainer = styled.div({
  backgroundColor: 'white',
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: '#f3f8f9',
  },
});

export const DetailsContainer = styled.div<IDetailsContainerProps>(
  {
    overflowX: 'hidden',
    overflowY: 'auto',
    transition: 'all .3s',
  },
  ({ expanded }) => ({
    maxHeight: expanded ? '9999px' : '0',
  }),
);
